var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 9.846,
    fill: "url(#paint0_linear_638_2354)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09521,
    y: 1.09583,
    width: 37.8082,
    height: 37.8082,
    rx: 9.3065,
    fill: "url(#paint1_linear_638_2354)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_2354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.5002H17V13.2502C17 12.4546 17.3161 11.6915 17.8787 11.1289C18.4413 10.5663 19.2044 10.2502 20 10.2502C21.4409 10.2502 22.7375 11.2815 23.015 12.6493C23.0562 12.8426 23.172 13.0118 23.3373 13.1202C23.5026 13.2285 23.7039 13.2673 23.8976 13.228C24.0913 13.1887 24.2616 13.0746 24.3716 12.9104C24.4816 12.7462 24.5224 12.5452 24.485 12.3512C24.0612 10.2643 22.175 8.75024 20 8.75024C18.8069 8.75149 17.663 9.22599 16.8194 10.0696C15.9757 10.9133 15.5012 12.0572 15.5 13.2502V15.5002H12.5C12.1022 15.5002 11.7206 15.6583 11.4393 15.9396C11.158 16.2209 11 16.6024 11 17.0002V27.5002C11 27.8981 11.158 28.2796 11.4393 28.5609C11.7206 28.8422 12.1022 29.0002 12.5 29.0002H27.5C27.8978 29.0002 28.2794 28.8422 28.5607 28.5609C28.842 28.2796 29 27.8981 29 27.5002V17.0002C29 16.6024 28.842 16.2209 28.5607 15.9396C28.2794 15.6583 27.8978 15.5002 27.5 15.5002ZM25.25 26.0002H14.75C14.5511 26.0002 14.3603 25.9212 14.2197 25.7806C14.079 25.6399 14 25.4492 14 25.2502C14 25.0513 14.079 24.8606 14.2197 24.7199C14.3603 24.5793 14.5511 24.5002 14.75 24.5002H25.25C25.4489 24.5002 25.6397 24.5793 25.7803 24.7199C25.921 24.8606 26 25.0513 26 25.2502C26 25.4492 25.921 25.6399 25.7803 25.7806C25.6397 25.9212 25.4489 26.0002 25.25 26.0002ZM25.25 23.0002H14.75C14.5511 23.0002 14.3603 22.9212 14.2197 22.7806C14.079 22.6399 14 22.4492 14 22.2502C14 22.0513 14.079 21.8606 14.2197 21.7199C14.3603 21.5793 14.5511 21.5002 14.75 21.5002H25.25C25.4489 21.5002 25.6397 21.5793 25.7803 21.7199C25.921 21.8606 26 22.0513 26 22.2502C26 22.4492 25.921 22.6399 25.7803 22.7806C25.6397 22.9212 25.4489 23.0002 25.25 23.0002ZM25.25 20.0002H14.75C14.5511 20.0002 14.3603 19.9212 14.2197 19.7806C14.079 19.6399 14 19.4492 14 19.2502C14 19.0513 14.079 18.8606 14.2197 18.7199C14.3603 18.5793 14.5511 18.5002 14.75 18.5002H25.25C25.4489 18.5002 25.6397 18.5793 25.7803 18.7199C25.921 18.8606 26 19.0513 26 19.2502C26 19.4492 25.921 19.6399 25.7803 19.7806C25.6397 19.9212 25.4489 20.0002 25.25 20.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_638_2354",
    x1: -11.5068,
    y1: -3.56164,
    x2: 40.294,
    y2: 39.6993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8561D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_638_2354",
    x1: 13.8784,
    y1: 2.53919,
    x2: 36.2639,
    y2: 44.1763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8561D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_2354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.00012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheft);
export default __webpack_public_path__ + "static/media/theft.4d4d23b3df0d9aa016ab1d342fcfbe6d.svg";
export { ForwardRef as ReactComponent };